<template>
  <div style="width:100%; height:100%;">
    <v-text-field
          v-model="search"
          label="Fragen durchsuchen"
          clearable
          append-icon="mdi-magnify"
        ></v-text-field>
    <v-tooltip bottom max-width="300">
      <template #activator="{ on: onTooltip }">
        <span v-bind="attrs" v-on="{ ...on, ...onTooltip }">
          <v-chip
              :class="allQuestions ? 'mr-2 filter-tag filter-tag__active' : 'mr-2 filter-tag'"
              :color="allQuestions ? 'secondary' : 'gray_5'"
              small
              :input-value="allQuestions"
              @click="toggleActive(0)"
          >
            Alle
          </v-chip>
        </span>
      </template>

      <span>Alle Fragen</span>
    </v-tooltip>
    <v-tooltip bottom max-width="300">
      <template #activator="{ on: onTooltip }">
        <span v-bind="attrs" v-on="{ ...on, ...onTooltip }">
          <v-chip
              :class="(isIwak && !allQuestions) ? 'mr-2 filter-tag filter-tag__active' : 'mr-2 filter-tag'"
              :color="(isIwak && !allQuestions) ? 'secondary' : 'gray_5'"
              small
              :input-value="isIwak"
              @click="toggleActive(1)"
          >
            Vordefiniert
          </v-chip>
        </span>
      </template>

      <span>Vordefinierte Fragen fließen in eine Bewertungsstruktur ein und können im weiteren Verlauf in Form von Bewertungen (1-6) an den Prozesselementen angezeigt werden. </span>
    </v-tooltip>
    <v-tooltip bottom max-width="300">
      <template #activator="{ on: onTooltip }">
        <span v-bind="attrs" v-on="{ ...on, ...onTooltip }">
          <v-chip
              :class="(isCustom && !allQuestions) ? 'mr-2 filter-tag filter-tag__active' : 'mr-2 filter-tag'"
              :color="(isCustom && !allQuestions) ? 'secondary' : 'gray_5'"
              small
              :input-value="isCustom"
              @click="toggleActive(2)"
          >
            Benutzerdefiniert
          </v-chip>
        </span>
      </template>

      <span>Benutzerdefinierte Fragen können unterschiedliche Fragetypen und eigene Fragen enthalten. Sie fließen jedoch nicht in eine Bewertungsstruktur ein, sondern können einzeln ausgewertet werden.</span>
    </v-tooltip>

    <v-list style="height:85%; overflow: auto">
      <v-list-item :class="isSelected(option.id)+' border-bottom'" v-for="option in availableQuestions"
                   :key="option.id"
                   @click="selectOption(option)">
      <v-list-item-content class="question">
          <div class="question-text">{{option.text}}</div>
      </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    selectedOptions: Array
  },
  data: function () {
    return {
      search: '',
      allQuestions: true,
      isCustom: true,
      isIwak: true
    };
  },
  mounted(){
  },
  computed:{
    availableQuestions(){
      let list = this.selectedOptions.concat(...this.options); 
      if(this.search && this.search != ''){
        list = list.filter(elem => elem.text.toLowerCase().includes(this.search.toLowerCase()));
      }
      list = this.filterList(list);
      return list;
    }
  },
  methods: {
    filterList(list) {
      if (this.isIwak && !this.isCustom) {
        return list.filter(elem => elem.node != null);
      } else if (this.isCustom && !this.isIwak) {
        return list.filter(elem => elem.node == null);
      } else if (!this.isIwak && !this.isCustom) {
        return [];
      }
      return list;
    },
    toggleActive(num) {
      if (num == 1) {
        this.isCustom = false;
        this.isIwak = true;
        this.allQuestions = false;
      } else if(num == 2) {
        this.isIwak = false;
        this.allQuestions = false;
        this.isCustom = true;
      } else {
        this.isCustom = true;
        this.isIwak = true;
        this.allQuestions = true;
      }
    },
    selectOption(selectedElement) {
      if (this.selectedOptions.length > 0 && this.selectedOptions.find(elem => elem.id == selectedElement.id) != null) {
        let index = this.selectedOptions.findIndex(elem => elem.id == selectedElement.id);
        this.selectedOptions.splice(index, 1);
        this.options.push(selectedElement)
        this.$emit("deselect", selectedElement.id)
      } else {
        let index = this.options.findIndex(elem => elem.id == selectedElement.id);
        this.options.splice(index, 1);
        this.selectedOptions.push(selectedElement);
        this.$emit("select", selectedElement.id)
      }
    },
    isSelected(id) {
      if (this.selectedOptions && this.selectedOptions.length > 0 && this.selectedOptions.find(elem => elem.id == id) != null) {
        return 'selected';
      }
    }
  }
}
</script>
<style lang="less" scoped>
.field{
  height: 40% !important;
  overflow:auto !important;
}
.fill{
  height:100%;
  width:100%
}
.box {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  padding: 25px !important;
  padding-top: 0px !important;
}
.selected{
  background-color: var(--green-color_s);
  font-weight: 600;
  margin:2.5px;
  .question {
    color: var(--green-color) !important;
  }
  .question-text {
    &::after {
      content: 'X';
      color: gray;
      font-family: 'Raleway';
      position: absolute;
      right: 10px;
      top: 40%;
    }
  }
}
.v-chip .v-chip__content{
  font-size: 0.75rem;
}
.filter-tag {
  font-weight: 500;
  color: var(--gray-color_3);
}
.filter-tag__active {
  font-weight: 600;
  color: #fff;
}
.question {
  font-size: 0.8rem;
  color: var(--gray-color);
}
</style>